import React, { useState, useEffect } from 'react'
import { IoIosClose } from 'react-icons/io'
import { injectIntl } from 'gatsby-plugin-intl'
import CookieDetais from './CookieDetails'
import AccordionMenu from './AccordionMenu'
import styled from 'styled-components'
import { colors, richTextOptions as options } from 'utils/utils'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

export default injectIntl(props => {
	const { 
		openMenu,
		menuClose,
		cookieMenuInfo,
		acceptAll,
		save,
		rejectAll,
		handleSwitchToggle,
		openDetails,
		openViewDetails,
		closeViewDetails,
		catSelected,
		catSwitchCheck,
		catAlwaysActive
	} = props

	const [categoryAlwaysActive, setCategoryAlwaysActive] = useState([])

	useEffect(() => {
		if(catAlwaysActive) {
			setCategoryAlwaysActive([...catAlwaysActive])
		}
	}, [catAlwaysActive])

	return (
		<>

			<CookieMenuOverlay className={openMenu ? 'open' : ''} onClick={menuClose}/>
			<CookieMenu className={openMenu ? 'open' : ''}>
				<MenuHeader>
					<Logo>
						<img src={cookieMenuInfo.logo.file.url} alt={cookieMenuInfo.logo.description} />
					</Logo>
					<Close id="closeCookieMenu" onClick={menuClose}><IoIosClose /></Close>
				</MenuHeader>
				<MenuContent>
					{
						!openDetails ?
							<>
								<Title>{cookieMenuInfo.title}</Title>
								<ContentText>{cookieMenuInfo.description.description}</ContentText>					
								<AcceptAllButton className="cookie-button" onClick={acceptAll}>{cookieMenuInfo.acceptAllButton}</AcceptAllButton>
								<AccordionSection>
									{
										cookieMenuInfo.category.filter(cat => cat.cookies).map(cat =>
											<AccordionMenu 
												key={cat.catId}
												title={cat.name}
												hasSwitch={true}											
												alwaysActive={categoryAlwaysActive.includes(cat.catId)}
												switchId={cat.catId}
												switchChecked={catSwitchCheck[cat.catId]}
												handleSwitchToggle={handleSwitchToggle}
												grayBackground={true}
											>
												<AccordionDescription>{cat.description.description}</AccordionDescription>
												<ViewDetails onClick={openViewDetails} data-id={cat.catId}>{cookieMenuInfo.viewDetails}</ViewDetails>
											</AccordionMenu>
										)
									}
								</AccordionSection>
								<FooterTitle>{cookieMenuInfo.footerTitle}</FooterTitle>
								<FooterDescription>{documentToReactComponents(cookieMenuInfo.footerDescription && cookieMenuInfo.footerDescription.json , options)}</FooterDescription>
							</>
						:
							<CookieDetais
								data={catSelected.cookies}
								category={catSelected.name}
								closeViewDetails={closeViewDetails}
								tableHeaders={cookieMenuInfo.tableHeaders}
								backButton={cookieMenuInfo.backButton}
							/>
					}

				</MenuContent>
				<MenuFooter>
					<RejectAllButton className="cookie-button" onClick={rejectAll}>{cookieMenuInfo.rejectAllButton}</RejectAllButton>
					<SaveConfirmButton className="cookie-button" onClick={save}>{cookieMenuInfo.saveConfirmButton}</SaveConfirmButton>
				</MenuFooter>
			</CookieMenu>
		</>
	)
})

const CookieMenuOverlay = styled.button`
	display: none;
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	height: stretch;
	border: 0;
	background-color: rgba(0, 0, 0, 0.3);
	z-index: 21474836489!important;

	&.open {
		display: block;
	}
`

const CookieMenu = styled.div`
	position: fixed;
	top: 0;
	left: -500px;
	width: 500px;
	max-width: 100vw;
	height: 100vh;
	height: stretch;
	transition: left .5s ease-in-out;
	background-color: ${colors.tertiary};
	z-index: 21474836490!important;

	&.open {
		left: 0;
	}

	button.cookie-button {
		display: block;
		padding: 1rem 0;
		border: 0;
		border-radius: .2rem;
		background-color: ${colors.secondary};
		color: ${colors.quinary};
		width: 48%;
		cursor: pointer;
	}
`

const MenuHeader = styled.div`
	width: 100%;
	padding: 0 2rem;
	border-bottom: solid .1rem ${colors.quinary};
	overflow: hidden;
`
	
const Logo = styled.div`
	position: relative;
	height: 4rem;
	img {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		height: 6rem;
		width: auto;
	}
`

const Close = styled.button`
	position: absolute;
	top: 0;
	right: 0;
	width: 2rem;
	height: 2rem;
	border: 0;
	background-color: transparent;
	padding: 1rem;
	cursor: pointer;
	box-sizing: content-box;

	svg {
		width: 100%;
		height: 100%;
	}
`

const MenuContent = styled.div`
	height: calc(100% - 9.5rem);
	overflow-y: auto;
	padding: .5rem 2rem;
`

const Title = styled.h3`
`

const ContentText = styled.span`
	line-height: 1.35;
`

const AcceptAllButton = styled.button`
	margin: 1.5rem 0;
`

const AccordionSection = styled.div`
	display: flex;
	flex-direction: column;
`

const FooterTitle = styled.h3`
	margin-top: 2rem;
`

const FooterDescription = styled.div`
	line-height: 1.35;

	ul {
		list-style: disc;
	}

`

const MenuFooter = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
	height: 5.5rem;
	border-top: solid .1rem ${colors.quinary};
	padding: 1rem 2rem;	
`
const RejectAllButton = styled.button`
`

const SaveConfirmButton = styled.button`
`

const AccordionDescription = styled.span`
	display: block;
	padding: 1rem 1rem 0;
`

const ViewDetails = styled.button`
	font-size: 0.7rem;
	padding: 1rem;
	border: 0;
	text-decoration: underline;
	cursor: pointer;
	background-color: transparent;
`